import React from 'react';
import { FormattedMessage } from 'react-intl';
import SelectOTA from '~/features/base/components/forms/ota/SelectOTA';
import MultiSelectOTA from '~/features/base/components/MultiSelectOTA';
import {
    useFetchVehicleEnergyTypesQuery,
    useFetchMmtHeadUnitsQuery,
    useFetchFunctionKeysQuery,
} from '~/api/mmt/MmtManagement.api';

interface MmtPropertiesFormItemProps {
    vehicleEnergyType?: string;
    mmtHeadUnit?: string;
    mmtFunctions?: string[];
    onChange: (values: {
        vehicleEnergyType?: string;
        mmtHeadUnit?: string;
        mmtFunctions?: string[];
    }) => void;
}

const MmtPropertiesFormItem: React.FC<MmtPropertiesFormItemProps> = ({
    vehicleEnergyType,
    mmtHeadUnit,
    mmtFunctions,
    onChange,
}) => {
    const { data: energyTypes = [] } = useFetchVehicleEnergyTypesQuery();
    const { data: headUnits = [] } = useFetchMmtHeadUnitsQuery();
    const { data: functionKeys = [] } = useFetchFunctionKeysQuery();

    const energyTypeOptions = energyTypes.map(type => ({ value: type, label: type, id: type }));
    const headUnitOptions = headUnits.map(unit => ({ value: unit, label: unit, id: unit }));
    const functionKeyOptions = functionKeys.map(key => ({ value: key, label: key, id: key }));

    return (
        <div className="margin-bottom-15">
            <div className={"margin-bottom-10"}><FormattedMessage id="intl-msg:mmtProperties" /></div>
            <div className={'display-flex gap-10'}>
                <div className='form-group width-50pct'>
                    <SelectOTA
                        title="intl-msg:vehicleEnergyType"
                        value={[vehicleEnergyType]}
                        options={energyTypeOptions}
                        useClear
                        onChange={(value: any) => {
                            onChange({
                                vehicleEnergyType: value?.id,
                                mmtHeadUnit,
                                mmtFunctions,
                            });
                        }}
                    />
                </div>
                <div className='form-group width-50pct'>
                    <SelectOTA
                        title="intl-msg:mmtHeadUnit"
                        value={[mmtHeadUnit]}
                        options={headUnitOptions}
                        useClear
                        onChange={(value: any) => {
                            onChange({
                                vehicleEnergyType,
                                mmtHeadUnit: value?.id,
                                mmtFunctions,
                            });
                        }}
                    />
                </div>
            </div>

            <div className='form-group'>
                <label><FormattedMessage id={'intl-msg:mmtFunctions'}/></label>
            <MultiSelectOTA
                useClear
                value={mmtFunctions}
                options={[...functionKeyOptions]}
                onChange={(value: any) => {
                    onChange({
                        vehicleEnergyType,
                        mmtHeadUnit,
                        mmtFunctions: value?.length > 0 ? value : undefined,
                    });
                }}
            />
                </div>
            </div>
    );
};

export default MmtPropertiesFormItem;
